import { zoom as d3Zoom, event, zoomIdentity } from 'd3';

export default (xScale, draw, mouseEvents, displayTranslate) => (selection) => {
  const zoom = d3Zoom();
  const { dx, dy } = displayTranslate;
  const extent = [[dx, 0], [dy, 0]];
  const shiftedTrasnform = (originTransform) => {
    const { x, y, k } = originTransform;

    return zoomIdentity
      .translate(x, y)
      .scale(k);
  };

  zoom
    .extent(extent)
    .translateExtent(extent)
    .scaleExtent([1, Infinity])
    .on('zoom', () => {
      const transform = shiftedTrasnform(event.transform);
      const newScale = transform.rescaleX(xScale);

      selection.call(draw(newScale, mouseEvents));
    });
  selection.call(zoom);

  return zoom;
};



// WEBPACK FOOTER //
// ./src/views/pages/completion/zoom.js